// extracted by mini-css-extract-plugin
export default {"AdminSidebar":"styles_AdminSidebar__uIzHM","desktop":"styles_desktop__gGtq7","mobile":"styles_mobile__OV364"};